import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";
import BoxFrame from "../entities/BoxFrame";


export default class FrameAnimation extends Animation {
  constructor(frame: PIXI.Sprite | BoxFrame, targetAlpha: number, duration: number, onComp: () => void) {
    super();
    new Tween.Tween(frame)
      .to({ alpha: targetAlpha }, duration)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => onComp())
      .start()
  }
}